<template>
  <div class="view chapter">
    <loader v-if="loading" />
    <transition name="fade">
    <template v-if="!loading">
      <div class="view-content">
        <div class="view-visual">
          <div class="view-visual-inner" v-rellax="{speed: -3}">
            <img
              :src="chapter.picture.src"
              :srcset="chapter.picture.src2x ? `${chapter.picture.src2x} 2x` : null"
              :alt="chapter.picture.alt"
            />
          </div>
        </div>
        <div class="container">
            <template>
              <button @click.prevent="onBack" class="view-backlink">
                <sprite
                  :type="'arrow-left'"
                  :width="19"
                  :height="12"
                />
                <span class="u-visually-hidden">{{ $t('back.hp') }}</span>
              </button>
              <h1 class="view-content-title h1" v-html="chapter.title">
              </h1>
              <div class="view-content-text typeset"
                   v-html="chapter.text">
              </div>
              <div class="view-content-video" v-if="chapter.video">
                    <video playsinline controls preload="metadata">
                      <source :src="`${chapter.video}#t=0.01`"
                              type="video/mp4">
                      {{ $t('video.support') }}
                    </video>
              </div>
              <spacer v-if="stories.length > 0" />
              <div class="view-content-slider" v-if="stories.length > 0">
                <h2 class="view-content-slider-title h3">
                  <!-- <span class="hat">{{ $t('chapters.stories_title') }}</span><br/> -->
                  <span v-html="chapter.title"></span>
                </h2>
                <slider
                  :isStories="true"
                  :slides="stories"
                />
              </div>
              <player v-if="chapter.audio" :file="chapter.audio" />
            </template>
        </div>
      </div>
    </template>
    </transition>
  </div>
</template>

<script>
import Loader from '@/components/components/Loader.vue';
import Spacer from '@/components/components/Spacer.vue';
import Sprite from '@/components/components/Sprite.vue';
import Player from '@/components/components/Player.vue';
import Slider from '@/components/partials/Slider.vue';

export default {
  components: {
    Loader,
    Spacer,
    Sprite,
    Player,
    Slider
  },
  beforeMount() {
    const { locale } = this.$route.params;
    const exhibitionId = this.$route.params.id;
    const { chapterId } = this.$route.params;
    if (!this.$store.state.exhibitions.item || this.$store.state.exhibitions.item.id !== exhibitionId) {
      this.$store.dispatch('exhibitions/getDetail', { id: exhibitionId, loc: locale });
    }
    if (!this.$store.state.user.item) {
      this.$store.dispatch('user/get', exhibitionId);
    }
    if (!this.$store.state.chapters.item || this.$store.state.chapters.item.id !== chapterId) {
      this.$store.dispatch('chapters/getDetail', { id: chapterId, loc: locale });
    }
    if (this.$store.state.stories.items.length === 0) {
      this.$store.dispatch('stories/get', { id: exhibitionId, loc: locale });
    }
  },
  computed: {
    chapter() {
      return this.$store.state.chapters.item;
    },
    chapterLoading() {
      return this.$store.state.chapters.requestsDetail !== 0;
    },
    stories() {
      return this.$store.state.stories.items.filter(s => s.chapter_id === this.chapter.id);
    },
    storiesLoading() {
      return this.$store.state.stories.requests !== 0;
    },
    userLoading() {
      return this.$store.state.user.requests !== 0;
    },
    loading() {
      return this.chapterLoading || this.storiesLoading || this.userLoading;
    }
  },
  watch: {
    $route(newRoute) {
      const { locale } = newRoute.params;
      const exhibitionId = newRoute.params.id;
      const { chapterId } = newRoute.params;
      this.$store.dispatch('chapters/getDetail', { id: chapterId, loc: locale });
      this.$store.dispatch('stories/get', { id: exhibitionId, loc: locale });
      this.$store.dispatch('exhibitions/getDetail', { id: exhibitionId, loc: locale });
      this.$store.dispatch('chapters/get', { id: exhibitionId, loc: locale });
      this.$store.dispatch('terms/get', locale);
    },
  },
  methods: {
    onBack() {
      this.$router.push({ name: 'Home' });
    }
  }
};
</script>

<style lang="scss" scoped>
.view {
  position: relative;
  background-color: $primary;

  // Visual
  // -----------------------------------------------------------------------------
  &-visual {
    @include aspect-ratio(1,1);
    overflow: hidden;

    &-inner {
      @include position(absolute, 0 0 0 0);
      height: 100%;
    }

    img {
      @include position(absolute, 0 0 0 0);
      @include size(100%);
      object-fit: cover;
    }
  }

  &-backlink {
    @include padding(15px 20px 15px 0);
    color: $tertiary;
    .svg {
      fill: $secondary;
    }
  }

  // Content
  // -----------------------------------------------------------------------------
  &-content {

    .container {
      @include padding(null null 100px);
    }

    &-title {
      @include margin(null null 20px);
      /* max-width: 245px; */
    }

    &-text {
      width: calc(100% - 80px);

      + .view-content-video {
        margin-top: 17px;
      }
    }

    &-video {
      video {
        width: 100%;
      }
    }

    &-slider {
      &-title {
        @include margin(null null 18px);
      }
    }
  }

  // Loader
  // -----------------------------------------------------------------------------
  .loader {
    @include position(absolute, 50% null null 50%);
    transform: translate(-50%, -50%);
  }
}
</style>
